// Vale considerar configurar nginx/apache nos clientes para devolver 404 em /_nuxt/builds/meta/*.json em vez de SPA fallback.
// Isso ativa o mecanismo nativo do Nuxt de "outdated build detection" — fica mais limpo arquiteturalmente.
// Mas o plugin já resolve o problema imediato sem precisar tocar em servidor.

const RELOAD_KEY = 'nuxt-manifest-reload-at'
const RELOAD_COOLDOWN_MS = 30_000

function reloadOnce() {
  const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0)
  if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) return

  sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  window.location.reload()
}

export default defineNuxtPlugin((nuxtApp) => {
  window.addEventListener('unhandledrejection', (event) => {
    const message = (event.reason as { message?: string } | undefined)?.message ?? ''
    if (!message.includes('[nuxt] Received malformed app manifest')) return

    event.preventDefault()
    reloadOnce()
  })

  // Chunk obsoleto após deploy: o cliente tem o index.html/chunk antigo em cache e tenta
  // importar dinamicamente um chunk que não existe mais ("Importing a module script failed").
  // Comum em Safari mobile por cache agressivo. Recarrega para buscar o build atual.
  nuxtApp.hook('app:chunkError', () => {
    reloadOnce()
  })
})
